import { CHANGE_LOGO, CHANGE_TITLE } from "../actions/types";
import config from "../config";

const initialState = {
	logoImage: ``,
	websiteTitle: "",
};

export default function (state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case CHANGE_LOGO:
			return { ...state, logoImage: payload };
		case CHANGE_TITLE:
			return { ...state, websiteTitle: payload };
		default:
			return state;
	}
}
